import { render, staticRenderFns } from "./LastTeishutsuPage.vue?vue&type=template&id=326aa8e2&scoped=true&"
import script from "./LastTeishutsuPage.vue?vue&type=script&lang=ts&"
export * from "./LastTeishutsuPage.vue?vue&type=script&lang=ts&"
import style0 from "./LastTeishutsuPage.vue?vue&type=style&index=0&id=326aa8e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "326aa8e2",
  null
  
)

export default component.exports